import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of, Subject } from "rxjs";
import { EstatusJSON } from "../../models/EstatusJSON";
import { environment } from "../../../../../environments/environment";
import { IApiBase } from "./Interface/IApiBase.interface";
import { CatalogPaginationRequest } from "../../models/CatalogPagination/CatalogPaginationRequest";
import { FilterRequest } from "../../models/Filter/FilterRequest";

@Injectable({
  providedIn: "root",
})
export class ViewsAPIService implements IApiBase{
  
  public isLoading$: Subject<boolean> = new Subject<boolean>();
  
  configUrl: string;
  public Result;
  estatus: EstatusJSON;
  constructor(private http: HttpClient) {
    this.configUrl = environment.host;
    this.estatus = new EstatusJSON();
  }
  insert() {
    throw new Error("Method not implemented.");
  }
  update(datos: any) {
    throw new Error("Method not implemented.");
  }
  delete(id: any) {
    throw new Error("Method not implemented.");
  }
  getFilterValues(request: FilterRequest[]) {
    throw new Error("Method not implemented.");
  }
  getPage(pageRequest: CatalogPaginationRequest) {
    throw new Error("Method not implemented.");
  }
  getCount(pageRequest: CatalogPaginationRequest) {
    throw new Error("Method not implemented.");
  }
  

  getList(): Observable<EstatusJSON> {
    return this.http.get<EstatusJSON>(this.configUrl + "/api/View/GetList", {});
  }

  getPermissionList(): Observable<EstatusJSON> {
    return this.http.get<EstatusJSON>(this.configUrl + "/api/View/getPermissionList", {});
  }

  
  
}
